import { OperationVariables, TypedDocumentNode } from '@apollo/client';
import { useMutation, useQuery } from '@apollo/client/react';
import QUERIES from 'services/gqlQueries';
import pluralize from 'pluralize';

export const useFetch = <TData, TVariables extends OperationVariables = OperationVariables>(
  method: string,
  resource: string,
  options?: useQuery.Options<TData, TVariables>
) => {
  let queryName = '';
  switch (method) {
    case 'GET_LIST':
      queryName = `get${pluralize(resource)}`;
      break;
    case 'GET_ONE':
      queryName = `get${resource}`;
      break;
  }
  const query = QUERIES[queryName] as TypedDocumentNode<TData, TVariables> | undefined;
  if (query) {
    return useQuery(query, {
      errorPolicy: 'all',
      ...options
    } as useQuery.Options<TData, TVariables>);
  }

  return {
    error: 'Not found query',
    data: null,
    previousData: undefined,
    loading: false,
    refetch: () => { }
  };
};

export const useMutate = <TData, TVariables extends OperationVariables = OperationVariables>(
  method: string,
  resource: string,
  options?: useMutation.Options<TData, TVariables>
) => {
  let queryName = '';
  switch (method) {
    case 'CREATE_ONE':
      queryName = `create${resource}`;
      break;
    case 'CREATE_MANY':
      queryName = `createMany${pluralize(resource)}`;
      break;
    case 'UPDATE_ONE':
      queryName = `update${resource}`;
      break;
    case 'UPDATE_MANY':
      queryName = `updateMany${pluralize(resource)}`;
      break;
    case 'DELETE_ONE':
      queryName = `delete${resource}`;
      break;
    case 'DELETE_MANY':
      queryName = `deleteMany${pluralize(resource)}`;
      break;
    case 'REORDER':
      queryName = `reorder${pluralize(resource)}`;
      break;
    default:
      queryName = `${method}${resource}`;
  }
  const mutate = QUERIES[queryName] as TypedDocumentNode<TData, TVariables> | undefined;
  if (mutate) {
    return useMutation(mutate, options as never);
  }

  return [null, { loading: true }] as const;
};
